/**
 * MinistrareIA - Product Service
 * API service for product (payment link) management
 */
import api from './api';

const BASE = '/api/products';

class ProductService {
  /** List all products (optionally filter by active status) */
  async list(active = null) {
    const params = {};
    if (active !== null) params.active = active;
    const response = await api.get(BASE, { params });
    return response.data;
  }

  /** Compras não concluídas (checkout preenchido, sem pagamento) */
  async listPendingOrders() {
    const response = await api.get(`${BASE}/orders/pending`);
    return response.data;
  }

  /** Get product by ID */
  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data;
  }

  /** Create a new product */
  async create(data) {
    const response = await api.post(BASE, data);
    return response.data;
  }

  /** Update product metadata */
  async update(id, data) {
    const response = await api.put(`${BASE}/${id}`, data);
    return response.data;
  }

  /** Toggle product active/inactive */
  async toggle(id, active) {
    const response = await api.put(`${BASE}/${id}/toggle`, { active });
    return response.data;
  }

  /** Payment Links existentes na conta Stripe (para importar como produto) */
  async stripeLinks(livemode = null) {
    const params = {};
    if (livemode !== null) params.livemode = livemode;
    const response = await api.get(`${BASE}/stripe/links`, { params });
    return response.data;
  }

  /** O que está configurado do Stripe no servidor (sem chaves) */
  async stripeStatus() {
    const response = await api.get(`${BASE}/stripe/status`);
    return response.data;
  }

  /** Delete product */
  async delete(id) {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  }
}

const productService = new ProductService();
export default productService;
